import React from "react";

export function CloseIcon({ color = '#222734', ...props }) {
  return (
    <svg width="32" height="31" viewBox="0 0 32 31" xmlns="http://www.w3.org/2000/svg" stroke={color} {...props}>
      <path d="M7.51562 7.61548L24.4862 23.4147" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.51562 23.4146L24.4862 7.61536" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
